<template>
  <div>
    <fieldset>
      <legend>
        <h3>Docusign Envelopes</h3>
      </legend>
    </fieldset>

    <div class="row">
      <div
        class="col-md-6 mb-3"
        :key="index"
        v-for="(envelope, index) in envelopes"
      >
        <div class="card mb-3 h-100">
          <div class="card-body text-center">
            <small class="text-muted">Name</small>
            <p class="mb-0">{{ envelope.name }}</p>

            <small class="text-muted">Email</small>
            <p class="mb-0">{{ envelope.email }}</p>

            <small class="text-muted">Email Subject</small>
            <p class="mb-0">{{ envelope.subject }}</p>

            <small class="text-muted">Sent By</small>
            <p class="mb-0">{{ envelope.generatedBy?.full_name }}</p>
            <small class="text-muted">Sent At</small>
            <p class="mb-0">{{ envelope.created_at ?? '-' }}</p>

            <small class="text-muted">Resent At</small>
            <p class="mb-0">{{ envelope.resend_at ?? '-' }}</p>

            <small class="text-muted">Status</small>
            <p class="mb-0">
              <envelope-status-badge :status="envelope.status" />
            </p>

            <small class="text-muted">Signed At</small>
            <p class="mb-0">{{ envelope.completed_at ?? '-' }}</p>

            <table class="table table-bordered table-striped table-sm">
              <thead>
                <tr>
                  <th>Document Type</th>
                  <th></th>
                </tr>
              </thead>
              <tbody v-if="envelope.envelopeDocuments?.length">
                <tr
                  v-bind:key="docIndex"
                  v-for="(envelopeDocument,
                  docIndex) in envelope.envelopeDocuments"
                >
                  <td>{{ getDocumentTypeName(envelopeDocument) }}</td>
                  <td>
                    <form-button
                      level="primary"
                      :indicator="downloading === envelopeDocument.identifier"
                      @clicked="downloadDocument(envelopeDocument, envelope)"
                    >
                      {{ getDownloadName(envelope) }}
                    </form-button>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td class="text-center" colspan="5">
                    No documents found
                  </td>
                </tr>
              </tbody>
            </table>

            <form-button
              v-if="showDeleteResend(envelope)"
              level="danger"
              :indicator="removing === envelope.identifier"
              @clicked="removeEnvelope(envelope)"
              class="mt-1"
              :block="true"
            >
              Delete
            </form-button>

            <form-button
              v-if="showDeleteResend(envelope)"
              level="warning"
              :indicator="resending === envelope.identifier"
              @clicked="resendEnvelope(envelope)"
              class="mt-1"
              :block="true"
            >
              Resend
            </form-button>

            <form-button
              level="primary"
              :indicator="downloading === envelope.identifier"
              @clicked="downloadCombinedDocument(envelope)"
              class="mt-1"
              :block="true"
            >
              Download Combined Documents
            </form-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormButton from '@/components/Generic/Form/FormButton';
import EnvelopeStatusBadge from '@/components/Modules/Shared/EnvelopeStatusBadge';

export default {
  props: {
    job: {
      type: Object,
      required: true
    },
    envelopes: []
  },

  components: {
    FormButton,
    EnvelopeStatusBadge
  },

  data() {
    return {
      loading: true,
      generate: true,
      showDeleteResendButton: false,
      dateTimeFormat: 'DD/MM/YYYY HH:mm',
      downloading: undefined,
      removing: undefined,
      resending: undefined
    };
  },

  mounted() {
    // this.loadEnvelopeDocuments();
  },

  methods: {
    // loadEnvelopeDocuments() {
    //   if (this.envelope) {
    //     this.generate = !!this.envelope.envelopeDocuments?.length;
    //     this.showDeleteResend(this.envelope);
    //   }
    //
    //   this.loading = false;
    // },

    showDeleteResend(envelope) {
      return (
        envelope && ['pending', 'sent', 'delivered'].includes(envelope?.status)
      );
    },

    getDocumentTypeName(envelopeDocument) {
      return (
        envelopeDocument.documentable?.type?.label ||
        envelopeDocument.documentable?.file_name
      );
    },

    getDownloadName(envelope) {
      switch (envelope.status) {
        case 'sent':
          return 'Download Unsigned';
        case 'delivered':
          return 'Download Delivered';
        case 'completed':
          return 'Download Signed';
        case 'declined':
          return 'Download Declined';
        default:
          return 'Download Document';
      }
    },

    downloadDocument(document, envelope) {
      this.downloading = document.identifier;

      if (envelope) {
        window.Ajax.download(
          `/jobs/${this.job.identifier}/envelopes/${envelope.identifier}/envelope-documents/${document.identifier}/download`
        )
          .then(() => (this.downloading = undefined))
          .catch(err => {
            this.downloading = undefined;

            window.toastify.error(
              'Oops',
              'An error occurred while downloading the document'
            );
          });
      }
    },

    downloadCombinedDocument(envelope) {
      if (envelope) {
        this.downloading = envelope.identifier;

        window.Ajax.download(
          `/jobs/${this.job.identifier}/envelopes/${envelope?.identifier}/download`
        )
          .then(() => (this.downloading = undefined))
          .catch(err => {
            this.downloading = undefined;

            window.toastify.error(
              'Oops',
              'An error occurred while downloading the documents'
            );
          });
      }
    },

    removeEnvelope(envelope) {
      window
        .swal({
          title: 'Are you sure?',
          text: 'This will permanently remove the envelope',
          type: 'warning',
          showCancelButton: true,
          input: 'textarea',
          inputPlaceholder:
            'Please enter the reason for removing the envelope.',
          inputValidator: value => {
            return new Promise((resolve, reject) => {
              if (value) {
                resolve(value);
              } else {
                reject('You must enter a reason.');
              }
            });
          }
        })
        .then(reason => {
          this.removing = envelope.identifier;
          window.Ajax.post(
            `/jobs/${this.job.identifier}/envelopes/${envelope.identifier}/delete`,
            { reason }
          )
            .then(response => {
              this.$emit('envelope-updated');

              window.toastify.success('Deleted', 'The envelope was deleted!');
            })
            .catch(err => {
              this.removing = undefined;
              window.toastify.error(
                'Error',
                'Sorry, there was an issue deleting the envelope.'
              );
            })
            .catch(() => {});
        });
    },

    resendEnvelope(envelope) {
      window
        .swal({
          title: 'Are you sure?',
          text: 'This will resend the envelope',
          type: 'warning',
          showCancelButton: true
        })
        .then(() => {
          this.resending = envelope.identifier;
          window.Ajax.put(
            `/jobs/${this.job.identifier}/envelopes/${envelope.identifier}/resend`
          )
            .then(response => {
              this.$emit('envelope-updated');
              this.resending = undefined;
              window.toastify.success(
                'Send',
                'The envelope resend successfully'
              );
            })
            .catch(err => {
              this.resending = undefined;
              window.toastify.error(
                'Error',
                'Sorry, there was an issue re sending the envelope.'
              );
            })
            .catch(() => {});
        });
    }
  }
};
</script>

<style scoped></style>
